import React, { FunctionComponent } from 'react'

type Props = {
	image: React.ReactNode
	label: string
	description: string
	onClick(): void
}

const LargeMenuItem: FunctionComponent<Props> = props => {
	const { image, label, description, onClick } = props
	return (
		<div className="menu__item menu__item--large" onClick={onClick}>
			<div className="menu__item-image">{image}</div>
			<div className="menu__item-content">
				<div className="menu__item-label">{label}</div>
				<small className="menu__item-description">{description}</small>
			</div>
		</div>
	)
}

export default LargeMenuItem
